import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";
import toastr from "toastr";
// core components
import Button from "components/CustomButtons/Button.jsx";
import clsx from "clsx";
import defaultImageData from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";

let defaultImage = `${defaultImageData}`;

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage,
      error: null
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleImageChange(e) {
    let fileData = e.target.files;

    this.handleSizeValidation(fileData).then(status => {
      if (status) {
        e.preventDefault();
        let reader = new FileReader();
        let file = fileData[0];
        let size = file !== undefined && file.size / (1024 * 1024);
        if (file.type !== "image/jpeg" && file.type !== "image/png") {
          return this.setState({
            error: `This file type is not supported!`,
            file: null
          });
        }
        if (size > 2) {
          return this.setState({
            error: `You can't upload files larger than 2MB!`,
            file: null
          });
        }
        reader.onloadend = () => {
          this.setState({
            file: file,
            imagePreviewUrl: reader.result
          });
        };
        reader.readAsDataURL(file);
        this.props.uploadImage(file);
      } else {
        toastr.error(`Please upload ${this.props.size} px`);

        this.setState({
          file: null
        });
      }
    });
  }
  handleSizeValidation = ([f]) => {
    let { size } = this.props;

    let checkSize = this.checkSize;

    return new Promise(resolve => {
      if (!size) {
        resolve(true);
        return "";
      }
      var _URL = window.URL || window.webkitURL;

      var file, img;
      if ((file = f)) {
        img = new Image();
        img.onload = function() {
          resolve(checkSize(this.width, this.height, size));
        };
        img.src = _URL.createObjectURL(file);
      }
    });
  };

  checkSize = (w, h, ratio) => {
    let [width, height] = ratio.split("*");

    if (parseInt(width) == w && parseInt(height) == h) {
      return true;
    }
    return false;
  };
  handleSubmit(e) {
    e.preventDefault();
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  handleRemove() {
    this.setState({
      file: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
    });
    this.refs.fileInput.value = null;
    this.props.uploadImage(null);
    if (this.props.removeImage) {
      this.props.removeImage();
    }
  }

  showError = () => {
    setTimeout(() => {
      this.setState({
        error: null
      });
    }, 3000);
    return (
      <div className="main_error_pop">
        <span className="snackbar_cus error_cus">{this.state.error}</span>
      </div>
    );
  };

  render() {
    var {
      avatar,
      addButtonProps,
      changeButtonProps,
      removeButtonProps,
      hide,
      currentProduct,
      className
    } = this.props;
    return (
      <div className={clsx(className, "fileinput text-center")}>
        {this.state.error && this.showError()}
        <input type="file" onChange={this.handleImageChange} ref="fileInput" />
        <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
          {currentProduct && currentProduct.image !== "" ? (
            <img src={currentProduct.image} alt="..." />
          ) : (
            <img src={`${this.state.imagePreviewUrl}`} alt="..." />
          )}
        </div>
        {!hide && (
          <div>
            {this.state.file === null ? (
              <Button {...addButtonProps} onClick={() => this.handleClick()}>
                {avatar ? "Add Photo" : "Upload Image"}
              </Button>
            ) : (
              <span>
                <Button
                  {...changeButtonProps}
                  onClick={() => this.handleClick()}
                >
                  Change
                </Button>
                {avatar ? <br /> : null}
                <Button
                  {...removeButtonProps}
                  onClick={() => this.handleRemove()}
                >
                  <i className="fas fa-times" /> Remove
                </Button>
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  currentProduct: PropTypes.any
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/ImageUpload.jsx